/** Кому открыт раздел xStocks, решает сервер (backend_v2/access.py; список
 *  правится в админке) и сообщает в /api/settings → `features`. Сервер
 *  проверяет то же сам (403) — здесь лишь прячем пункты меню. */
import type { UserSettings } from '../types';

type Who = Pick<UserSettings, 'username' | 'features'> | null | undefined;

/** Старый сервер (до админки) поля `features` не присылал — тогда прежний список. */
const LEGACY_USERS = ['daeddman', 'maxll'];

export const canSeeXStocks = (user: Who): boolean => {
  if (!user?.username) return false;
  if (Array.isArray(user.features)) return user.features.includes('xstocks');
  return LEGACY_USERS.includes(user.username.toLowerCase());
};
